import * as React from 'react';
import Record from '../logic/domain/transits/Record';
import TransitView from './TransitView';
import { addPath } from '../logic/service/RecordsForMonthService';
import CostView from './CostView';
import { is, Map } from 'immutable';
import BaseComponent from './BaseComponent';
import PathView from './PathView';
import pathToUpdate from 'src/logic/type/pathToUpdate';

interface Props {
  index: number;
  record: Record;
  handleUpdateRecord: Function;
  handleDeleteRecord: Function;
  handleCost: Function;
  pathToUpdate: pathToUpdate;
}
interface State {
  isLoading: boolean;
  display: boolean;
}

class RecordView extends BaseComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: true,
      display: true
    };
  }
  shouldComponentUpdate(nextProps: Props, nextState: State) {
    const toDiff = is(Map(nextProps.record.to), Map(this.props.record.to));
    const fromDiff = is(
      Map(nextProps.record.from),
      Map(this.props.record.from)
    );
    const stateDiff = is(Map(nextState), Map(this.state));
    return !(toDiff && fromDiff && stateDiff);
  }
  componentDidMount() {
    const { pathToUpdate, record } = this.props;
    this.calcCost(pathToUpdate, record);
  }
  preDelete() {
    const { pathToUpdate, handleDeleteRecord } = this.props;
    this.setState({
      display: false
    });
    setTimeout(() => {
      handleDeleteRecord(pathToUpdate);
    }, 800);
  }
  private async calcCost(pathToUpdate: pathToUpdate, record: Record) {
    this.setState({
      isLoading: true
    });
    await this.props.handleCost(pathToUpdate, record);
    this.setState({
      isLoading: false
    });
  }
  render() {
    const paddingTop5px = {
      paddingTop: '5px'
    };
    const {
      index,
      record,
      handleUpdateRecord,
      // handleDeleteRecord,
      pathToUpdate
    } = this.props;
    const { from, to, cost } = this.props.record;
    const pathForFrom = addPath(pathToUpdate, ['from']);
    const pathForTo = addPath(pathToUpdate, ['to']);

    return (
      <tr
        className={
          this.state.display ? 'fadeOutObject' : 'fadeOutObject is-hide'
        }
      >
        <th>
          <span style={paddingTop5px}>{index}</span>
        </th>
        <td>
          <span className="select">
            <select>
              <option>電車</option>
              <option>バス</option>
            </select>
          </span>
        </td>
        <td>
          <TransitView
            transit={from}
            handleUpdateRecord={handleUpdateRecord}
            pathToUpdate={pathForFrom}
          />
        </td>
        <td>
          <TransitView
            transit={to}
            handleUpdateRecord={handleUpdateRecord}
            pathToUpdate={pathForTo}
          />
        </td>
        <td style={paddingTop5px}>
          <PathView isLoading={this.state.isLoading} cost={cost} />
        </td>
        <td>
          <CostView isLoading={this.state.isLoading} cost={cost} />
        </td>
        <td>
          <p style={paddingTop5px}>
            <button
              className="button is-danger is-outlined"
              onClick={e => this.preDelete()}
            >
              <span>Delete</span>
              <span className="icon is-small">
                <i className="fas fa-times" />
              </span>
            </button>
          </p>
          <p style={paddingTop5px}>
            <button
              className="button is-success is-outlined"
              onClick={e => this.calcCost(pathToUpdate, record)}
            >
              <span>Recalc</span>
              <span className="icon">
                <i className="fas fa-calculator" />
              </span>
            </button>
          </p>
        </td>
      </tr>
    );
  }
}

export default RecordView;



// WEBPACK FOOTER //
// ./src/components/RecordView.tsx